<template lang="pug">
.row.align-items.center.px-15.flex.gap-8(v-if="showInfo")
  .div.info-banner
    .col-sm-11
      i.fa.fa-info-circle.text-blue.pr-5
      span.info-text
        | Only the desktop app records screenshots. If screenshots are required, edit allowed apps in member settings. #[a(href="https://support.hubstaff.com/time-tracker-apps-overview/") Learn more]
    .col-sm-1.pull-right.dismiss-button
      a.dismiss.text-bright-blue.text-right(@click="showDismissDialogue")
        | Dismiss
  AppDialog.activities-dismiss-warning-dialog(
    :title="title"
    append-to-body
    :show="showDismiss"
    @close="hideDismissDialogue"
  )
    .row.dismiss-body
      .col-sm-12
        p You are dismissing a warning about why screenshots are not showing up on this page
      .dismiss-warnings-footer.col-sm-12.modal-footer.d-flex.justify-content-end.px-15.mb-0.flex-wrap.gap-10.pb-10
        AppButton(@click="hideInfoBannerPermanently")
          | Never show again
        AppButton.pr-30.mt-0(
          type="primary"
          @click="dismissThisTime"
        )
          | Dismiss just this time
</template>
<script>
import { UserResource } from '~/resources';

export default {
  name: 'ActivitiesInfoBanner',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Dismiss warnings',
    },
  },
  data() {
    return {
      showDismiss: false,
      showInfo: this.show,
    };
  },
  methods: {
    hideDismissDialogue() {
      this.showDismiss = false;
    },
    dismissThisTime() {
      this.hideDismissDialogue();
      this.showInfo = false;
    },
    showDismissDialogue() {
      this.showDismiss = true;
    },
    closeAndHide() {
      this.hideDismissDialogue();
      this.dismissThisTime();
    },
    async hideInfoBannerPermanently() {
      let response;

      try {
        response = await UserResource.hideActivityInfoBanner();
      } catch (err) {
        throw new Error('Unable to update the setting');
      } finally {
        if (response && response.success) {
          this.closeAndHide();
        }
      }
    },
  },
};
</script>
